module.exports = __webpack_public_path__ + "static/Finance-9f07767cbcea768af721726188e49431.png";